<template>
  <modal :show.sync="modals.modal1" footerClasses="text-right" :largeModal="true">
    <h6
      slot="header"
      class="modal-title text-success font-weight-bold"
      id="modal-title-default"
    >{{title}}</h6>
    <div class="d-block">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form ref="form" @submit.stop.prevent="handleSubmit(submit)">
          <p class="description">* Registrasi Wajib Pajak, silahkan isi field di bawah ini.</p>
          <div class="alert alert-danger" v-if="error_msg.length > 0">
            <strong>Warning!</strong> Perbaiki hasil input Anda :
            <ul>
              <li v-for="text in error_msg" :key="text">{{text}}</li>
            </ul>
          </div>
          <div class="mb-5">
            <!-- /.page-header -->
            <div class="row">
              <div class="col-md-12">
                <!-- / PAGE CONTENT START -->
                <div class="row">
                  <div class="col-md-4 col-sm-12">
                    <div class="form-group">
                      <select
                        class="form-control"
                        v-model="form.group"
                        :class="'is-valid'"
                      >
                        <option value="1">1 - Badan</option>
                        <option selected="selected" value="2">2 - Pribadi</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <ValidationProvider name="Jenis Usaha" rules="required" v-slot="{ errors }">
                      <div class="form-group">
                        <select
                          class="form-control"
                          v-model="form.business_id"
                          :class="[{'is-valid': (!errors[0]) === true}, {'is-invalid': (!errors[0]) === false}]"
                        >
                          <option value disabled selected>--- Pilih Jenis usaha ---</option>
                          <option value="1">01 - HOTEL</option>
                          <option value="2">02 - RESTORAN</option>
                          <option value="3">03 - HIBURAN</option>
                          <option value="4">04 - REKLAME</option>
                          <option value="5">05 - PPJ</option>
                          <option value="7">07 - PARKIR</option>
                          <option value="8">08 - AIR TANAH</option>
                          <option value="9">09 - WALET</option>
                          <option value="12">11 - MBLB</option>
                        </select>
                        <div
                          class="text-danger invalid-feedback"
                          style="display: block;"
                          :class="{'mt-2': hasIcon}"
                          v-if="errors[0]"
                        >{{ errors[0] }}</div>
                      </div>
                    </ValidationProvider>
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <base-input
                      placeholder="NPWPD"
                      v-model="form.npwpd"
                      :disabled="true"
                      :valid="true"
                    ></base-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-8 col-sm-12">
                    <ValidationProvider name="Nama Usaha" rules="required" v-slot="{ errors }">
                      <base-input
                        placeholder="Nama Usaha"
                        v-model="form.business_name"
                        :required="true"
                        :error="errors[0]"
                        :valid="!errors[0]"
                      ></base-input>
                    </ValidationProvider>
                  </div>

                  <div class="col-md-4 col-sm-12">
                    <ValidationProvider name="No. Telp Usaha" rules="numeric" v-slot="{ errors }">
                      <base-input
                        placeholder="No. Telp Usaha"
                        v-model="form.contact_number_business"
                        :required="true"
                        :error="errors[0]"
                        :valid="!errors[0]"
                      ></base-input>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-8">
                    <ValidationProvider
                      name="Alamat Tempat Usaha"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <base-text-area
                        placeholder="Alamat Tempat Usaha"
                        v-model="form.business_address"
                        :required="true"
                        :error="errors[0]"
                        :valid="!errors[0]"
                      ></base-text-area>
                    </ValidationProvider>
                  </div>

                  <div class="col-md-2 col-sm-12">
                    <ValidationProvider name="RT" rules="numeric" v-slot="{ errors }">
                      <base-input
                        placeholder="RT"
                        v-model="form.rt"
                        :required="true"
                        :error="errors[0]"
                        :valid="!errors[0]"
                      ></base-input>
                    </ValidationProvider>
                  </div>

                  <div class="col-md-2 col-sm-12">
                    <ValidationProvider name="RW" rules="numeric" v-slot="{ errors }">
                      <base-input
                        placeholder="RW"
                        v-model="form.rw"
                        :required="true"
                        :error="errors[0]"
                        :valid="!errors[0]"
                      ></base-input>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                      <ValidationProvider name="Kecamatan" rules="required" v-slot="{ errors }">
                        <v-select
                          :options="districts"
                          v-model="form.district_id"
                          :reduce="district => district.id"
                          label="name"
                          class="form-control"
                          :class="[{'is-valid': !errors[0]}, {'is-invalid': errors[0]}]"
                          placeholder="~~ Pilih Kecamatan ~~"
                          @input="get_villages"
                        ></v-select>
                        <div
                          class="text-danger invalid-feedback"
                          style="display: block;"
                          v-if="errors[0]"
                        >{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <div class="form-group">
                      <ValidationProvider
                        name="Kelurahan / Desa"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <v-select
                          :options="villages"
                          v-model="form.village_id"
                          :reduce="village => village.id"
                          label="name"
                          class="form-control"
                          :class="[{'is-valid': !errors[0]}, {'is-invalid': errors[0]}]"
                          placeholder="~~ Pilih Kelurahan / Desa ~~"
                        ></v-select>
                        <div
                          class="text-danger invalid-feedback"
                          style="display: block;"
                          v-if="errors[0]"
                        >{{ errors[0] }}</div>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <base-text-area
                      placeholder="Keterangan"
                      v-model="form.explanation"
                      :valid="true"
                    ></base-text-area>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-8 col-sm-12">
                    <ValidationProvider name="Nama Pemilik" rules="required" v-slot="{ errors }">
                      <base-input
                        placeholder="Nama Pemilik"
                        v-model="form.owner_name"
                        :required="true"
                        :error="errors[0]"
                        :valid="!errors[0]"
                      ></base-input>
                    </ValidationProvider>
                  </div>

                  <div class="col-md-4 col-sm-12">
                    <ValidationProvider name="No. Telp Pemilik" rules="numeric" v-slot="{ errors }">
                      <base-input
                        placeholder="No. Telp Pemilik"
                        v-model="form.contact_number_owner"
                        :required="true"
                        :error="errors[0]"
                        :valid="!errors[0]"
                      ></base-input>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-8">
                    <ValidationProvider name="Alamat Pemilik" rules="required" v-slot="{ errors }">
                      <base-text-area
                        placeholder="Alamat Pemilik"
                        v-model="form.owner_address"
                        :required="true"
                        :error="errors[0]"
                        :valid="!errors[0]"
                      ></base-text-area>
                    </ValidationProvider>
                  </div>

                  <div class="col-md-2 col-sm-12">
                    <ValidationProvider name="RT Pemilik" rules="numeric" v-slot="{ errors }">
                      <base-input
                        placeholder="RT Pemilik"
                        v-model="form.rt_pemilik"
                        :required="true"
                        :error="errors[0]"
                        :valid="!errors[0]"
                      ></base-input>
                    </ValidationProvider>
                  </div>

                  <div class="col-md-2 col-sm-12">
                    <ValidationProvider name="RW Pemilik" rules="numeric" v-slot="{ errors }">
                      <base-input
                        placeholder="RW Pemilik"
                        v-model="form.rw_pemilik"
                        :required="true"
                        :error="errors[0]"
                        :valid="!errors[0]"
                      ></base-input>
                    </ValidationProvider>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4 col-sm-12">
                    <base-input
                      placeholder="Kecamatan Pemilik"
                      v-model="form.kecamatan_pemilik"
                      :required="true"
                      :valid="true"
                    ></base-input>
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <base-input
                      placeholder="Kelurahan / Desa Pemilik"
                      v-model="form.kelurahan_pemilik"
                      :required="true"
                      :valid="true"
                    ></base-input>
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <base-input
                      placeholder="Kabupaten Pemilik"
                      v-model="form.kabupaten_pemilik"
                      :required="true"
                      :valid="true"
                    ></base-input>
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <base-input
                      placeholder="Nomor NPWP"
                      v-model="form.npwp"
                      :required="true"
                      :valid="true"
                    ></base-input>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-4 col-sm-12">
                    <base-input placeholder="KTP" v-model="form.ktp" :required="true" :valid="true"></base-input>
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <base-input placeholder="NOP" v-model="form.nop" :required="true" :valid="true"></base-input>
                  </div>
                  <div class="col-md-4 col-sm-12">
                    <base-input
                      placeholder="Email"
                      v-model="form.email_wp"
                      :required="true"
                      :valid="true"
                    ></base-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- / PAGE CONTENT ENDS -->
          <div class="row float-right">
            <div class="col-md-12 col-sm-12">
              <template v-if="isBusy">
                <pulse-loader :loading="isBusy" :color="'#d7f6e8'"></pulse-loader>
                <strong>Loading...</strong>
              </template>
              <base-button
                v-else
                type="success"
                nativeType="submit"
                icon="ni ni-send"
              >{{edit ? "Update" : "Daftar"}}</base-button>
              <base-button type="warning" @click="modals.modal1 = false">Tutup</base-button>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </modal>
</template>
<script>
import Modal from "@/components/Modal.vue";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import Swal from "sweetalert2";
import qs from "qs";
import axios from "axios";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
export default {
  components: {
    Modal,
    PulseLoader,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  props: {
    title: {
      type: String,
      description: "Judul Modal",
    },
    code: {
      type: String,
      description: "Code Pajak",
    },
    url: {
      type: String,
      description: "Url Pajak",
    },
  },
  data() {
    return {
      modals: {
        modal1: false,
      },
      form: {
        id: null,
        business_id: null,
        group: 2,
        business_name: null,
        contact_number_business: null,
        business_address: null,
        village_id: null,
        district_id: null,
        explanation: null,
        npwp: null,
        owner_name: null,
        contact_number_owner: null,
        owner_address: null,
        rt: null,
        rw: null,
        rt_pemilik: null,
        rw_pemilik: null,
        email_wp: null,
        nop: null,
        ktp: null,
        business_id: null,
        npwpd: null,
      },
      isBusy: false,
      districts: [],
      villages: [],
      error_msg: [],
      edit: false,
    };
  },
  methods: {
    showModal() {
      this.items = [];
      this.edit = false;
      this.form.id = null;
      this.modals.modal1 = true;
      this.form.business_id = null;
      this.form.owner_name = null;
      this.form.owner_address = null;
      this.form.contact_number_owner = null;
      this.form.business_name = null;
      this.form.contact_number_business = null;
      this.form.business_address = null;
      this.form.village_id = null;
      this.form.district_id = null;
      this.form.explanation = null;
      this.form.npwp = null;
      this.form.rt = null;
      this.form.rw = null;
      this.form.rt_pemilik = null;
      this.form.rw_pemilik = null;
      this.form.email_wp = null;
      this.form.nop = null;
      this.form.ktp = null;
      this.form.kabupaten_pemilik = null;
      this.form.npwpd = null;
      this.get_districts();
    },
    updateMode(data) {
      this.form.owner_name = data.owner_name;
      this.form.owner_address = data.owner_address;
      this.form.contact_number_owner = data.contact_number_owner;
      this.form.business_name = data.business_name;
      this.form.contact_number_business = data.contact_number_business;
      this.form.business_address = data.business_address;
      this.form.village_id = data.village_id;
      this.form.district_id = data.district_id;
      this.form.explanation = data.explanation;
      this.form.npwp = data.npwp;
      this.form.id = data.id;
      this.form.rt = data.rt;
      this.form.rw = data.rw;
      this.form.rt_pemilik = data.rt_pemilik;
      this.form.rw_pemilik = data.rw_pemilik;
      this.form.email_wp = data.email_wp;
      this.form.rt_pemilik = data.nop;
      this.form.rw_pemilik = data.ktp;
      this.form.business_id = data.business_id;
      this.form.kabupaten_pemilik = data.kabupaten_pemilik;
      this.form.npwpd = data.npwpd;
      this.get_villages(data.district_id);
      this.edit = true;
    },
    hideModal() {
      this.modals.modal1 = false;
    },
    async submit() {
      const me = this;
      try {
        me.error_msg = [];
        this.isBusy = true;
        let { data, status } = me.edit
          ? await axios.patch(
              "/api/v1/registrations/" + me.form.id,
              qs.stringify({ registration: me.form })
            )
          : await axios.post(
              "/api/v1/registrations",
              qs.stringify({ registration: me.form })
            );

        if (status >= 200 && status <= 202) {
          Swal.fire({
            title: "",
            text: me.edit
              ? "Update data berhasil."
              : "Registrasi Berhasil, Terima kasih sudah mendaftar. Harap tunggu verifikasi Admin. Terima kasih",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Tutup!",
          }).then(() => {
            this.$store.dispatch("auth/set_user", data);
            me.hideModal();
          });
        }
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
        // console.log(error.response);
        me.error_msg = error.response.data;
        Swal.fire({
          title: "",
          text: error.message,
          type: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Tutup!",
        });
      } finally {
        this.isBusy = false;
      }
    },
    async get_districts() {
      try {
        this.districts = [];
        this.isBusy = true;
        let { data } = await axios.get("/api/v1/districts/all");
        this.districts = data;
        this.isBusy = false;
      } catch (error) {
        Swal.fire({
          title: "",
          text: error.message,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Tutup!",
        });
        this.isBusy = false;
      } finally {
        this.isBusy = false;
      }
    },
    async get_villages(id) {
      try {
        this.villages = [];
        this.isBusy = true;
        let { data } = await axios.get("/api/v1/districts/villages/" + id);
        this.villages = data;
      } catch (error) {
        Swal.fire({
          title: "",
          text: error.message,
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Tutup!",
        });
      } finally {
        this.isBusy = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-dialog {
  max-width: 80% !important;
  margin: 1.75rem auto;
}
</style>